// extracted by mini-css-extract-plugin
export default {"blogImage":"PFSBlogView_blogImage__-zXxs","icons":"PFSBlogView_icons__dJEWs","editor":"PFSBlogView_editor__ZhRpe","ButtonContainer":"PFSBlogView_ButtonContainer__G8yUW"};